// Oswald font da google
WebFontConfig = {
  google: { families: [ 'Oswald::latin' ] },
  loading: function(){
    setTimeout(function(){
      jQuery(".franchise").css("visibility", "visible");
      fix_h1_text();
    }, 500)
  }
};
(function(){
  var wf = document.createElement('script');
  wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
    '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

function setHeightMenuFooter(){
  var maxHeightFooter=0;
  jQuery('#menu-footer > li').each(function(){
    var linkMenuFooter=jQuery(this).children('a');
    var childUl=jQuery(this).children('ul');
    var wMenuFooter=0;
    if(jQuery.browser.msie && parseInt(jQuery.browser.version, 10) == 7) {
      wMenuFooter=linkMenuFooter.height();
    }
    else {
      wMenuFooter=linkMenuFooter.width();
    }
    linkMenuFooter.css("height",wMenuFooter+'px');
  });
}

function showRanking(){
  jQuery('#content-rank-home').children().hide();
  var showRank = jQuery('#team-rank').val();
  jQuery(showRank).show();
}

// function carouselEventsAll(start){
//   jcarousel = jQuery('#carousel-events-all');
//   jcarousel.jcarousel({
//     vertical: true,
//     animation: 1000,
//     scroll: 1,
//     start: parseInt(start, 10),
//     initCallback: callbackCarouselEventsAll
//   });
// }

// function carouselOtherEvents(prevText,nextText){
//   jQuery("#carousel-other-events").jcarousel({
//     vertical: true,
//     animation: 1500,
//     scroll: 3,
//     buttonPrevHTML: "<div class=\"gradient-under-btn\"><div class=\"label-top big bg-color4 fg klein-medium\">"+nextText+"</div></div>",
//     buttonNextHTML: "<div class=\"gradient-under-btn\"><div class=\"bg-white absolute\"></div><div class=\"label-bottom big bg-color4 klein-medium fg\">"+prevText+"</div></div>"
//   });
// }

function get_next_page_wp_posts(next_page_posts_wp, id){
  var link = document.location.protocol + "//" + window.location.hostname + next_page_posts_wp;
  jQuery.ajax({
    url: link,
    timeout: 60000,
    complete: function(xhr) {
      var page_number = next_page_posts_wp.match(/([0-9]+)\/\??[^\/]*$/);
      var data = xhr.responseText;
      jQuery("#page-"+page_number[1]+"-content").html(data);

      var new_href = next_page_posts_wp.replace(/[0-9]+\/(\??[^\/]*)$/,(parseInt(page_number[1],10)+1)+"/$1");
      jQuery('#'+id).attr('href',new_href);

      jQuery("#loading-articles").hide();
      jQuery("#btn-other-articles").show();
      refreshAddThis();
    }
  });
}

function showNextBoxAlbums(box){
  if(jQuery.browser.msie && parseInt(jQuery.browser.version, 10) == 7)
    jQuery("#box"+box+"-albums").show();
  else
    jQuery("#box"+box+"-albums").slideToggle("slow");
  if(jQuery("#box"+(box+1)+"-albums").length === 0){
    jQuery("#btn-other-albums a").removeClass("o80");
    jQuery("#btn-other-albums a").removeClass("o100");
    jQuery("#btn-other-albums a").addClass("o40");
  }
  fix_gallery_sizes();
}

function showNextBoxMedias(box){
  if(jQuery.browser.msie && parseInt(jQuery.browser.version, 10) == 7)
    jQuery("#box"+box+"-medias").show();
  else
    jQuery("#box"+box+"-medias").slideToggle("slow");
  if(jQuery("#box"+(box+1)+"-medias").length===0){
    jQuery("#btn-other-medias a").removeClass("o80");
    jQuery("#btn-other-medias a").removeClass("o100");
    jQuery("#btn-other-medias a").addClass("o40");
  }
}

function setHeightContent(){
  var wWindow, hWindow, hHeader, hFooter, hWrapper, hPage, h_shadow_col, diff;
  wWindow = $(window).width();
  hWindow = $(window).height();
  hHeader = $('#box-header').outerHeight();
  hFooter = $('#box-footer').outerHeight();
  hWrapper = $("#wrapper-page").outerHeight();
  if(wWindow > 800) hWrapper = hWrapper + 8
  hPage = hHeader + hFooter + hWrapper;
  if(window.h_window == undefined || window.h_page == undefined || window.h_window != hWindow || window.h_page != hPage){
    $('#big-col .set-height-box').css('minHeight', '');
    hWrapper = $("#wrapper-page").outerHeight();
    hPage = hHeader + hFooter + hWrapper
    diff = (hPage < hWindow) ? (hWindow - hPage) : 0;
    if(wWindow > 720)
      h_shadow_col = ($('#content').height() > $('#big-col').outerHeight()) ? ($('#content').height() - 5 - $('#big-col h1').height() + diff) : ($('#big-col .set-height-box').outerHeight() + diff);
    else
      h_shadow_col = $('#big-col .set-height-box').outerHeight() + diff;
    $('#big-col .set-height-box').css('minHeight', h_shadow_col);
    window.h_window = hWindow;
    window.h_page = hPage;
  }
}

function callbackSlideshow(){
  var boxThumb = jQuery("#info-photo-slideshow").find(".box-thumb");
  boxThumb.show();
  jQuery('#featured-slideshow').children().each(function(){
    if(jQuery(this).css('opacity')==1) {
      var nSlide=jQuery(this).data().iterator;
      var prevslide = nSlide-1;
      if(prevslide < 0) prevslide = jQuery('#featured-slideshow').children().length;
      jQuery('#box-thumb-slideshow .box-thumb').removeClass("br-orange");
      jQuery('.slide-'+nSlide).addClass("br-orange");
      /*jQuery('.slide-'+nSlide).hide();
      jQuery('.slide-'+prevslide).show();
      if(nSlide) boxThumb.removeClass("first");*/
      var link=jQuery(this).find('[data-href]').data().href;
      jQuery("#info-photo-slideshow").find(".readall").attr("href",link);
    }
  });
}

jQuery(document).ready(function($){
  if(jQuery('#slideshow').length > 0){
    // Commentare la riga sotto e fare il nuovo slideshow responsive
    // slideshow();
  }

  refreshAddThis();
  setHeightMenuFooter();
  setHeightContent();
  setTimeout(setHeightContent, 1000);

  $(".hover-shadow").each(function(){
    $(this).hover(function(){
      $(this).toggleClass("shadow");
    },function(){
      $(this).toggleClass("shadow");
    });
  });

  $(".event-block").each(function(){
    $(this).hover(function(){
      boxs = $(this).find(".bg-color3-80");
      boxs.addClass("bg-color3");
      boxs.removeClass("bg-color3-80");
    },function(){
      if(!$(this).hasClass("next-event")){
        boxs = $(this).find(".bg-color3");
        boxs.addClass("bg-color3-80");
        boxs.removeClass("bg-color3");
      }
    });
  });

  $(".shadow6").each(function(){
    $(this).hover(function(){
      $(this).toggleClass("shadow12");
    },function(){
      $(this).toggleClass("shadow12");
    });
  });

  $(".rank-team").each(function(){
    $(this).find("table").addClass("gradient-gray-h");
    $(this).find("table").find("tr:even").addClass("bg-white");
  });

  var next_page_posts_wp = 2;
  $("#more-articles").on("click",function(event){
    event.preventDefault();
    if(!$(this).hasClass('o40')){
      $("#loading-articles").show();
      $("#btn-other-articles").hide();
      get_next_page_wp_posts($(this).attr('href'),$(this).attr('id'));
      next_page_posts_wp++;
    }
  });

  $("#box-single-post .box-description .desc .addthis_toolbox").before("<div class=\"line-title\"></div>");
  $("#box-page-standard .desc .addthis_toolbox").before("<div class=\"line-title\"></div>");

  $(".single-page textarea").on("click",function(event){
    event.preventDefault();
    if($(this).val() == $(this).attr('data-default')){
      var wrapComments = $('.wrap-comments-content');
      var showComments = $("#show-comments");
      $(this).val('');
      $(this).css('height','60px');
      $('.single-page input[type=submit]').css('display','block');
      $('.single-page form').css('paddingBottom','38px');
      var actual = showComments.html();
      var titleBtn = showComments.attr("title");
      if(actual != titleBtn) wrapComments.height('100%');
    }
  });
  $(".single-page textarea").on("focus",function(event){
    if($(this).val() == $(this).attr('data-default')){
      var wrapComments = $('.wrap-comments-content');
      var showComments = $("#show-comments");
      $(this).val('');
      $(this).css('height','60px');
      $('.single-page input[type=submit]').css('display','block');
      $('.single-page form').css('paddingBottom','38px');
      var actual = showComments.html();
      var titleBtn = showComments.attr("title");
      if(actual != titleBtn) wrapComments.height('100%');
    }
  });
  $("#show-comments").on("click",function(event){
    event.preventDefault();
    var wrapComments = $('.wrap-comments-content');
    var commentsContent = $('.comments-content');
    var textareaComment = $(".single-page textarea");
    var showComments = $(this);
    var next = showComments.attr('data-opposite-text');
    var actual = showComments.html();
    var titleBtn = showComments.attr("title");
    if(actual != titleBtn){
      wrapComments.height('100%');
      commentsContent.css('display','block');
    }else{
      wrapComments.height(40);
      commentsContent.css('display','none');
      textareaComment.css('height','15px');
      if(textareaComment.val() === ""){
        textareaComment.val(textareaComment.attr('data-default'));
      }
      $('.single-page input[type=submit]').css('display','none');
      $('.single-page form').css('paddingBottom','9px');
    }
    showComments.attr('data-opposite-text',actual);
    showComments.html(next);
  });

  $(".comments-content li .reply a").addClass("label-middle bg-yellow shadow");

  var numberBoxAlbum=2;
  $("#btn-other-albums a").on("click",function(event){
    event.preventDefault();
    showNextBoxAlbums(numberBoxAlbum);
    numberBoxAlbum++;
  });

  var numberBoxMedia=2;
  jQuery("#btn-other-medias a").on("click",function(event){
    event.preventDefault();
    showNextBoxMedias(numberBoxMedia);
    numberBoxMedia++;
  });

  jQuery("#advanced-search").on("click",function(){
    jQuery(this).parents("#search-media").find(".toggle-class").toggleClass("none");
    jQuery(this).parents("#search-media").children("form").toggleClass("border-dotten-bottom");
    jQuery("#search_keys, #box-btn-search, #advanced-search, #search-media").toggleClass("big");
    if(jQuery("#right-col-search-media").is(":visible")){
      jQuery("#search-media select").each(function(){
        jQuery(this).children().each(function(){
          if(!jQuery(this).hasClass("default")) jQuery(this).removeAttr("selected");
          else jQuery(this).attr("selected","selected");
        });
      });
    }
  });

  if(jQuery(".box-search").length>0){
    var currentPageA = window.location.href;
    jQuery("#small-col").find("a").each(function(){
      if(!$(this).hasClass("label-bottom"))
        $(this).addClass("fg2")
    });
    var currentLinkA = jQuery("#small-col").find("a[href='"+currentPageA+"']");
    if(!currentLinkA.hasClass("label-bottom")){
      currentLinkA.removeClass("fg2");
      currentLinkA.addClass("fg3");
    }
  }

  var association_name_header = $("#header table tr td.title a");
  if(association_name_header.height() > association_name_header.parent().height() && $(window).width() > 800)
    association_name_header.parent().css({fontSize: '28px', lineHeight: '34px'});

  $('[data-jcarousel-control]').on("jcarouselcontrol:inactive", function(){
    $(this).addClass('inactive');
  });
  $('[data-jcarousel-control]').on("jcarouselcontrol:active", function(){
    $(this).removeClass('inactive');
  });

  $('#carousel-events-all').on('jcarousel:animate', function(){
    $(this).find('a.selected').removeClass('selected');
  });

  // Serve per quando si clicca sul calendario per far andare all'evento all'interno del carousel
  $('a[data-date]').bind('click', function(event, prevent){
    var carousel = $(this).parents('[data-jcarousel]');
    if(carousel.attr('id') == 'carousel-events-all'){
      if(!typeof(prevent) === "undefined") event.preventDefault();
      var temp_startjCarousel = $(this).parents('li').index();
      carousel.find('a.selected').removeClass('selected');
      carousel.jcarousel('scroll', temp_startjCarousel);
      $(this).addClass('selected');
    }
  });

  $('[data-jcarousel]').each(function(){
    var el = $(this);
    el.jcarousel(el.data());
    var start_el = $("#"+el.attr('id')+"-start");
    if(start_el.length > 0 && start_el.data('start')){
      el.jcarousel('scroll', start_el.data('start'));
    }
    // PARTE RESPONSIVE: RISTEMARE
    // .on('jcarousel:reload jcarousel:create', function () {
    //   var carousel = $(this);
    //   var width = carousel.innerWidth();
    //   if(width >= 600){
    //     width = width / 3;
    //   } else if (width >= 350){
    //     width = width / 2;
    //   }
    //   carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
    // });
  });

  $('[data-jcarousel-control]').each(function(){
    var el = $(this);
    el.jcarouselControl(el.data());
  });

  // if($('#carousel-events-all').length > 0){
  //   start = $('#carousel-events-all .jcarousel-control-prev').data('start');
  //   carouselEventsAll(start);
  // }
  // $('.jcarousel-control-prev').on('jcarouselcontrol:active', function(){
  //   $(this).removeClass('inactive');
  // }).on('jcarouselcontrol:inactive', function(){
  //   $(this).addClass('inactive');
  // }).jcarouselControl({
  //   target: '-=1'
  // });

  // $('.jcarousel-control-next').on('jcarouselcontrol:active', function(){
  //   $(this).removeClass('inactive');
  // }).on('jcarouselcontrol:inactive', function() {
  //   $(this).addClass('inactive');
  // }).jcarouselControl({
  //   target: '+=1'
  // });

  $('#privacy-policy').addClass('bg-color2');
  $('#privacy-policy h3').addClass('textcenter franchise uppercase');
  $('#privacy-policy h3').after('<div class="line-title"></div>');

});

jQuery(window).load(function(){});

jQuery(window).on('resize', function(){
  setHeightContent();
});

arrowsTrigger(".photo-single","#btn-prev","left");
arrowsTrigger(".photo-single","#btn-next","right");

window.htmltorgb = function(hex){
  var r, g, b;
  hex = hex.replace(/^\s*#|\s*$/g, '');
  if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1');
  r = parseInt(hex.substr(0, 2), 16);
  g = parseInt(hex.substr(2, 2), 16);
  b = parseInt(hex.substr(4, 2), 16);
  return [r,g,b];
}
window.alter_brightness = function(hex, percent) {
  rgb = htmltorgb(hex);
  r = rgb[0];
  g = rgb[1];
  b = rgb[2];
  return '#' + ((0 | (1 << 8) + r + (256 - r) * percent / 100).toString(16)).substr(1) + ((0 | (1 << 8) + g + (256 - g) * percent / 100).toString(16)).substr(1) + ((0 | (1 << 8) + b + (256 - b) * percent / 100).toString(16)).substr(1);
};

jQuery(function($) {
  window.box_background_color2_backend = function(newval) {
    var _style, _final_color1, _style1, _final_color2, _style2, _final_color3, _style3, _style4;
    _final_color1 = alter_brightness(newval, 73);
    _style1 = "border-top: 1px solid "+ _final_color1 +"!important;";
    _final_color2 = alter_brightness(newval, -10);
    _style2 = "border: 1px solid "+ _final_color2 +"!important;";
    _final_color3 = alter_brightness(newval, -20);
    _style3 = "border-bottom: 1px solid "+ _final_color3 +"!important;";
    _style4 = "text-shadow: 3px 3px 0 "+ _final_color3 +"!important; filter: dropshadow(color="+ _final_color3 +", offx=3, offy=3)!important;";
    _style5 = "text-shadow: 1px 1px 0 "+ _final_color3 +"!important; filter: dropshadow(color="+ _final_color3 +", offx=1, offy=1)!important;";
    _style = "\
      #header table tr td.last div, #wrap-box-title-header p { " + _style1 + " }\
      #menu ul li ul, #menu > ul > li > a:hover, #menu > ul > li > a:focus, #menu > ul > li.sfHover > a { " + _style2 + " }\
      #wrap-box-title-header p, #header table tr td.title { " + _style3 + " }\
      .title a, .subtitle p { " + _style4 + " }\
      #wrap-box-site-info { " + _style5 + " }";
    return _style;
  };

  window.box_background_color3_backend = function(newval) {
    var _style, _final_color1, _style1, _final_color2, _style2, _final_color3, _style3, _final_color4, _style4, _style8, _style9, _style10;
    _final_color1 = alter_brightness(newval, 80);
    _style1 = "background-color: "+ _final_color1 +"!important;";
    _final_color2 = alter_brightness(newval, 80);
    _style2 = "border-bottom: 1px solid "+ _final_color2 +"!important;";
    _final_color3 = alter_brightness(newval, -10);
    _style3 = "border: 1px solid "+ _final_color3 +"!important;";
    _final_color4 = alter_brightness(newval, -20);
    _style4 = "background-color: "+ _final_color4 +"!important;";
    _style_8 = "\
      -webkit-box-shadow: "+ newval +" 0 0 8px;\
      -moz-box-shadow: "+ newval +" 0 0 8px;\
      box-shadow: "+ newval +" 0 0 8px;"
    _style_9 = "\
      -webkit-box-shadow: "+ newval +" 0 0 6px;\
      -moz-box-shadow: "+ newval +" 0 0 6px;\
      box-shadow: "+ newval +" 0 0 6px;"
    _style_10 = "\
      -webkit-box-shadow: "+ newval +" 0 0 12px;\
      -moz-box-shadow: "+ newval +" 0 0 12px;\
      box-shadow: "+ newval +" 0 0 12px;"
    _style = "\
      .bg-color3-80 { " + _style1 + " }\
      #line-header, #line-footer, #line-footer2 { " + _style2 + " }\
      #line-header, #line-footer, #line-footer2 { " + _style4 + " }\
      .shadow { " + _style8 + " }\
      .shadow6 { " + _style9 + " }\
      .shadow12 { " + _style10 + " }\
      ";
    return _style;
  };

  window.box_background_color4_backend = function(newval) {
    var _style, _final_color1, _style1;
    _final_color1 = alter_brightness(newval, 80);
    _style1 = "background-color: "+ _final_color1 +"!important;";
    _style = "#datepicker td.highlight a { " + _style1 + " }";
    return _style;
  };

  window.box_background_color5_backend = function(newval) {
    var _style, _final_color1, _style1;
    _final_color1 = alter_brightness(newval, -5);
    _style1 = "border-color: "+ _final_color1 +"!important;";
    _style = ".btn-middle, .btn-left, .btn-right { " + _style1 + " }";
    return _style;
  };
});


// Fix per responsive

function move_sidebar_elements(){
  var w_window = $(window).width();
  var ids = ['#sponsors-sidebar', '#other-products-sidebar', '#box-search-date', '#box-search-category', '#box-related_posts', '#most-view.related.video', '#other-events'];
  $.each(ids, function(idx,id){
    if($(id).length > 0){
      if(w_window <= 720 && $(id).parents('#after-big-col').length == 0){
        $(id).appendTo('#after-big-col');
        $('#after-big-col').addClass('show');
      } else if(w_window > 720 && $(id).parents('#small-col').length == 0){
        $(id).appendTo('#small-col');
        $('#after-big-col').removeClass('show');
      }
      if(!$(id).is(':visible')) $(id).show();
    }
  });
}

function fix_h1_text(){
  var h1_back = $('h1 + .btn-back');
  if(h1_back.length == 0) h1_back = $('h1').parent().find('.link-back');
  if(h1_back.length > 0 && $('h1 span').position().left < (h1_back.position().left + h1_back.outerWidth()))
    $('h1').addClass('space-top');
  else
    $('h1').removeClass('space-top');
}

function fix_gallery_sizes(){
  if($('.content-albums .album').length > 0){
    img = $('.content-albums .album img');
    img.each(function(){
      if($(this).attr('style')) $(this).removeAttr('style');
    });
    if($(window).width() <= 360 || img.hasClass('video')){
      img.removeClass('normal');
      img.data('rac', 'true');
      img.attr('data-rac', 'true');
      data_resize_and_center();
    } else {
      $('.content-albums .album img').addClass('normal');
    }
  }
  if($('#most-view .box-img img').length > 0){
    img = $('#most-view .box-img img');
    img.removeAttr('style');
    img.data('rac', 'true');
    img.attr('data-rac', 'true');
    data_resize_and_center();
  }
}

function resizeAndCenterImages(){
  var w_window = $(window).width();
  $('#carousel-events-all .event-block .wrap-event-img img').removeAttr('style');
  $('#carousel-events-all .event-block .wrap-event-img img').attr('data-rac', 'true');
  $('#carousel-other-events li .box-img .wrap-img img').removeAttr('style');
  $('#carousel-other-events li .box-img .wrap-img img').attr('data-rac', 'true');
  $('#box-events .event-block .wrap-event-img img').removeAttr('style');
  $('#box-events .event-block .wrap-event-img img').attr('data-rac', 'true');
  $('#event-home .box-locandina img').removeAttr('style');
  $('#event-home .box-locandina img').attr('data-rac', 'true');
  $('#video-home img').removeAttr('style');
  $('#video-home img').attr('data-rac', 'true');

  $('#box-single-event .box-img img').removeAttr('style');
  if(w_window <= 500){
    $('#box-single-event .box-img img').attr('data-rac', 'true');
  } else {
    $('#box-single-event .box-img img').removeAttr('data-rac');
  }

  data_resize_and_center();
  // data_center_image();
}

function fixCarouselEventsAll(){
  var refreshJcarousel = false;
  var w_window = $(window).width();
  var links = $("#carousel-events-all .event-block");
  if(w_window <= 360){
    if(links.first().parent().children().length != 1){
      links.unwrap();
      for(var i = 0; i < links.length; i+=1){
        links.slice(i, i+1).wrapAll("<li></li>");
      }
      refreshJcarousel = true;
    }
  } else if(w_window <= 540){
    if(links.first().parent().children().length != 2){
      links.unwrap();
      for(var i = 0; i < links.length; i+=2){
        links.slice(i, i+2).wrapAll("<li></li>");
      }
      refreshJcarousel = true;
    }
  } else {
    if(links.first().parent().children().length != 3){
      links.unwrap();
      for(var i = 0; i < links.length; i+=3){
        links.slice(i, i+3).wrapAll("<li></li>");
      }
      refreshJcarousel = true;
    }
  }
  if(refreshJcarousel) $("#carousel-events-all").jcarousel("reload");
}

function fixCarouselOtherEvents(){
  var refreshJcarousel = false;
  var w_window = $(window).width();
  var links = $("#carousel-other-events li > a");
  if(w_window <= 460 || w_window > 720){
    if(links.first().parent().children().length != 1){
      links.unwrap();
      for(var i = 0; i < links.length; i+=1){
        klass = i%2 == 0 ? 'gradient-gray-h' : '';
        links.slice(i, i+1).wrapAll("<li class='"+klass+"'></li>");
      }
      refreshJcarousel = true;
    }
  } else if(w_window <= 720){
    if(links.first().parent().children().length != 2){
      links.unwrap();
      var klass = 'gradient-gray-h';
      for(var i = 0; i < links.length; i+=2){
        klass = klass == '' ? 'gradient-gray-h' : '';
        links.slice(i, i+2).wrapAll("<li class='"+klass+"'></li>");
      }
      refreshJcarousel = true;
    }
  }
  if(refreshJcarousel) $("#carousel-events-all").jcarousel("reload");
}

function changeNumSlideItemCarousel(num, parent){
  parent.find('.slide-win-prev').attr('data-target', '-='+num);
  parent.find('.slide-win-prev').data('target', '-='+num);
  parent.find('.slide-win-next').attr('data-target', '+='+num);
  parent.find('.slide-win-next').data('target', '+='+num);
}

function fixMatchesCarousel(){
  if($('.teams-page').length > 0 || $('.game-page').length > 0){
    var refreshJcarousel = false;
    var w_window = $(window).width();
    var num = 5;
    var content_carousel = $('.teams-page #matches .matches-wrapper').length > 0  ? $('.teams-page #matches .matches-wrapper') : $('.game-page #matches .matches-wrapper');
    var wrap_carousel = content_carousel.parent();
    var w_content = content_carousel.width();
    if((w_window <= 950 && w_window > 785) || (w_window <= 660 && w_window > 550)){
      num = 4;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if((w_window <= 785 && w_window > 720) || (w_window <= 550 && w_window > 435)){
      num = 3;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 435){
      num = 2;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else {
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    }

    if(refreshJcarousel){
      content_carousel.jcarousel("reload");
      wrap_carousel.find('.slide-win-prev').jcarouselControl("reload", $('.slide-win-prev').data());
      wrap_carousel.find('.slide-win-next').jcarouselControl("reload", $('.slide-win-next').data());
    }
  } else if($('.content-blocks-home #carousel-matches-bar').length > 0){
    var refreshJcarousel = false;
    var w_window = $(window).width();
    var num = 8;
    var content_carousel = $('.content-blocks-home #carousel-matches-bar');
    var wrap_carousel = content_carousel.parent();
    var w_content = content_carousel.width();

    if(w_window <= 999 && w_window > 880){
      num = 7;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 880 && w_window > 770){
      num = 6;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 770 && w_window > 660){
      num = 5;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 660 && w_window > 540){
      num = 4;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 540 && w_window > 430){
      num = 3;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 430){
      num = 2;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    }
  }
}

function fixGamesCarousel(){
  if($('.teams-page').length > 0 || $('.game-page').length > 0){
    var refreshJcarousel = false;
    var w_window = $(window).width();
    var num = 3;
    var content_carousel = $('.teams-page #matches .matches-wrapper').length > 0  ? $('.teams-page #matches .matches-wrapper') : $('.game-page #matches .matches-wrapper');
    var wrap_carousel = content_carousel.parent();
    var w_content = content_carousel.width();
    if((w_window <= 920 && w_window > 720) || (w_window <= 640 && w_window > 460)){
      num = 2;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 460){
      num = 1;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else {
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    }

    if(refreshJcarousel){
      content_carousel.jcarousel("reload");
      wrap_carousel.find('.slide-win-prev').jcarouselControl("reload", $('.slide-win-prev').data());
      wrap_carousel.find('.slide-win-next').jcarouselControl("reload", $('.slide-win-next').data());
    }
  } else if($('.content-blocks-home #carousel-games-bar').length > 0){
    var refreshJcarousel = false;
    var w_window = $(window).width();
    var num = 5;
    var content_carousel = $('.content-blocks-home #carousel-games-bar');
    var wrap_carousel = content_carousel.parent();
    var w_content = content_carousel.width();
    if(w_window <= 999 && w_window > 810){
      num = 4;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 810 && w_window > 630){
      num = 3;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 630 && w_window > 450){
      num = 2;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    } else if(w_window <= 450){
      num = 1;
      if(wrap_carousel.find('.slide-win-prev').data('target') != "-="+num){
        changeNumSlideItemCarousel(num, wrap_carousel);
        refreshJcarousel = true;
      }
    }
    if(refreshJcarousel){
      content_carousel.jcarousel("reload");
      wrap_carousel.find('.slide-win-prev').jcarouselControl("reload", $('.slide-win-prev').data());
      wrap_carousel.find('.slide-win-next').jcarouselControl("reload", $('.slide-win-next').data());
    }
  }
}

jQuery(document).ready(function($){
  // TODO: Aggiungere messaggio che dice di aggiornare il browser se IE < 10???
  if($('#wrap-box-title-header .shadow').length > 0 && ($('#wrap-box-title-header .shadow').height()-7) > $('#header').height()){
    $('#box-header').css('minHeight', ($('#wrap-box-title-header .shadow').height()-7));
  }

  if($(window).width() <= 800) $('.sf-menu').addClass('mobile');
  $('#menu-mobile').on('click', function(event){
    event.preventDefault();
    var menu = $('#menu');
    if(menu.hasClass('open')){
      $('#menu').removeClass('open');
      $('#menu').css('top', '');
      $('#menu').css('maxHeight', '');
      $('#menu ul.children').removeClass('open');
    } else {
      var _top = $('#header').height() + 30;
      var _max_height = $(window).height() - _top;
      $('#menu').css('top', _top);
      $('#menu').css('maxHeight', _max_height);
      $('#menu').addClass('open');
    }
  });

  $('#menu ul .page_item').on('click', function(event){
    if($('#menu-mobile').is(':visible') && $(this).children('ul.children').length > 0){
      if(!$(this).children('ul.children').hasClass('open')){
        event.preventDefault();
        $('#menu ul.children').removeClass('open')
        $(this).children('ul.children').addClass('open');
        if($(this).parent('ul.children').length > 0) $(this).parent('ul.children').addClass('open');
      } else {
        if($(this).attr('href') == '#') $(this).children('ul.children').removeClass('open')
      }
    }
  });

  move_sidebar_elements();
  fix_gallery_sizes();
  fixCarouselEventsAll();
  fixCarouselOtherEvents();
  fixMatchesCarousel();
  fixGamesCarousel();

  $("#start_route").on('calcRoute', function(){
    setTimeout(setHeightContent, 1000);
  });

  $('body').on('ajaxHTML5:complete', function(){
    $(".franchise").css("visibility", "visible");
    fix_h1_text();
  });

  $('[data-jcarousel-control]').each(function(){
    var el = $(this);
    el.jcarouselControl(el.data());
  });

  $('[data-jcarousel]').each(function(){
    var el = $(this);
    el.jcarousel(el.data());
  });
});

jQuery(window).on('resize', function(){
  var w_window = $(window).width();

  if(w_window <= 800)
    $('.sf-menu').addClass('mobile');
  else
    $('.sf-menu').removeClass('mobile');

  if(w_window > 800 && $('#wrap-box-title-header .shadow').length > 0 && ($('#wrap-box-title-header .shadow').height()-7) > $('#header').height()){
    $('#box-header').css('minHeight', ($('#wrap-box-title-header .shadow').height()-7));
  }

  if($(window).width() <= 800 && $('#menu').is(':visible')){
    $('#menu').removeClass('open');
    $('#menu ul.children').removeClass('open');
  }

  if(w_window > 999) setHeightMenuFooter();

  var h1_back = $('h1 + .btn-back');
  if(h1_back.length > 0 && $('h1 span').position().left < (h1_back.position().left + h1_back.outerWidth()))
    $('h1').addClass('space-top');
  else
    $('h1').removeClass('space-top');

  move_sidebar_elements();
  fix_h1_text();
  fix_gallery_sizes();
  fixCarouselEventsAll();
  fixCarouselOtherEvents();
  resizeAndCenterImages();
  fixMatchesCarousel();
  fixGamesCarousel();

  if($('.ui-dialog').is(':visible')){
    if(w_window > 320){
      if(w_window > 470){
        var _left = parseInt(((w_window - $('.ui-dialog').width()) / 2), 10);
        $('.ui-dialog').css({
          left: _left,
          right: '',
          width: '100%'
        });
      } else {
        $('.ui-dialog').css({
          left: 10,
          right: 10,
          width: 'auto'
        });
      }
      $('.ui-dialog .ui-dialog-content').dialog('option', 'position', {my: "top", at: "top", of: window, offset: "0 30"})
    }
  }
});

jQuery(document).on('click', function(event){
  var w_window = $(window).width();
  var target = event.target;
  if(w_window <= 800 && $('#menu').hasClass('open') && $(target).parents('#menu').length == 0 && $(target).attr('id') != 'menu' && $(target).attr('id') != 'menu-mobile'){
    $('#menu').removeClass('open');
    $('#menu ul.children').removeClass('open');
  }
});